import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import { JOB_STATUS, jobStatus } from "@/utils/szStatus";

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const d = payload[0];
  return (
    <div className="rounded-lg border border-[#E6E9EF] bg-white px-3 py-2 shadow-lg">
      <p className="text-[11px] font-semibold text-[#0C1120]">{d.name}</p>
      <p className="text-[13px] font-bold" style={{ color: d.payload.fill, fontFamily: "Poppins,sans-serif" }}>
        {d.value} jobs
      </p>
    </div>
  );
};

const DashboardJobsChart = ({ jobsByStatus, totalJobs, loading, isDark }) => {
  if (loading) return <div className="sz-card h-[300px] animate-pulse" />;

  const data = (jobsByStatus || [])
    .map((s) => {
      const cfg = JOB_STATUS[s.name] || jobStatus(s.name);
      return { name: cfg.label, value: s.count, fill: cfg.fg };
    })
    .filter((d) => d.value > 0);

  const total = totalJobs || data.reduce((s, d) => s + d.value, 0);

  return (
    <section className="sz-card" style={{ padding: "20px 22px" }}>
      <h3 className="text-[15px] font-bold text-[#0C1120]" style={{ fontFamily: "Poppins,sans-serif" }}>
        Jobs by Status
      </h3>
      <div className="mt-[3px] text-[12px] text-[#8A90A2]">Current distribution</div>

      {data.length === 0 ? (
        <div className="flex h-[200px] items-center justify-center text-[13px] text-[#8A90A2]">
          No job data yet
        </div>
      ) : (
        <div className="mt-2 flex items-center gap-[18px]">
          <div className="relative flex-none" style={{ width: 150, height: 150 }}>
            <ResponsiveContainer width={150} height={150}>
              <PieChart>
                <Pie
                  data={data}
                  cx="50%"
                  cy="50%"
                  innerRadius={52}
                  outerRadius={72}
                  paddingAngle={1.5}
                  dataKey="value"
                  stroke="none"
                >
                  {data.map((entry, idx) => (
                    <Cell key={idx} fill={entry.fill} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
            <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center">
              <span className="text-[30px] font-bold leading-none text-[#0C1120]" style={{ fontFamily: "Poppins,sans-serif" }}>
                {total}
              </span>
              <span className="mt-1 text-[11px] text-[#8A90A2]">jobs</span>
            </div>
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-[7px]">
            {data.map((s, idx) => (
              <div key={idx} className="flex items-center gap-2 text-[11.5px]">
                <span className="h-[9px] w-[9px] flex-none rounded-[3px]" style={{ background: s.fill }} />
                <span className="flex-1 truncate text-[#2B3142]">{s.name}</span>
                <span className="font-semibold text-[#0C1120]" style={{ fontFamily: "Poppins,sans-serif" }}>{s.value}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default DashboardJobsChart;
